import React from 'react';
import './SupportPage.css';

const AboutUs = () => {
  return (
    <div className="support-page">
      <div className="support-header">
        <h1 className="support-title">About V Football</h1>
        <p className="support-subtitle">
          Your ultimate destination for live football scores, news, and match updates from leagues around the world.
        </p>
      </div>
      
      <div className="support-content">
        <h2>Our Mission</h2>
        <p>
          At V Football, we're passionate about bringing you the most comprehensive and up-to-date football coverage from around the globe. 
          Our mission is to provide football fans with instant access to live scores, match updates, news, and analysis from all major leagues and tournaments.
        </p>
        
        <h2>What We Offer</h2>
        <ul>
          <li><strong>Live Scores:</strong> Real-time updates from matches across 25+ European leagues</li>
          <li><strong>Match Coverage:</strong> Detailed statistics, team lineups, and live commentary</li>
          <li><strong>League Tables:</strong> Up-to-date standings for all major competitions</li>
          <li><strong>News & Analysis:</strong> Breaking news, transfer updates, and expert analysis</li>
          <li><strong>Team Information:</strong> Comprehensive data on over 400 football clubs</li>
          <li><strong>Mobile Experience:</strong> Optimized for all devices and screen sizes</li>
        </ul>
        
        <h2>Our Coverage</h2>
        <p>
          We cover the biggest football leagues and competitions from across Europe and beyond:
        </p>
        <ul>
          <li>English Premier League</li>
          <li>Spanish La Liga</li>
          <li>German Bundesliga</li>
          <li>Italian Serie A</li>
          <li>French Ligue 1</li>
          <li>Dutch Eredivisie</li>
          <li>Portuguese Liga Portugal</li>
          <li>And many more...</li>
        </ul>
        
        <h2>Our Team</h2>
        <p>
          V Football is built by a dedicated team of football enthusiasts, developers, and sports journalists who share a common goal: 
          to create the best possible experience for football fans worldwide. We work around the clock to ensure our platform 
          delivers accurate, timely, and comprehensive football coverage.
        </p>
        
        <h2>Technology & Innovation</h2>
        <p>
          Our platform leverages cutting-edge technology to deliver real-time updates and seamless user experience. 
          We use advanced data feeds, responsive design, and optimized performance to ensure you never miss a moment of the action.
        </p>
        
        <div className="info-box">
          <p>
            <strong>Join millions of football fans</strong> who trust V Football for their daily dose of football news, 
            scores, and updates. Whether you're following your local team or keeping track of international competitions, 
            we've got you covered.
          </p>
        </div>
        
        <h2>Contact Us</h2>
        <p>
          Have questions, suggestions, or feedback? We'd love to hear from you! 
          Visit our <a href="/contact">Contact page</a> to get in touch with our team.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;